const categories = [
  { emoji: '🔥', name: '热血格斗', count: '328部', color: 'bg-primary-100 text-primary-700' },
  { emoji: '💕', name: '恋爱甜宠', count: '256部', color: 'bg-accent-100 text-accent-700' },
  { emoji: '🧙', name: '奇幻冒险', count: '412部', color: 'bg-secondary-100 text-secondary-700' },
  { emoji: '🔍', name: '悬疑推理', count: '187部', color: 'bg-primary-100 text-primary-700' },
  { emoji: '😂', name: '搞笑日常', count: '203部', color: 'bg-accent-100 text-accent-700' },
  { emoji: '🌸', name: '治愈温情', count: '145部', color: 'bg-secondary-100 text-secondary-700' },
  { emoji: '⚔️', name: '武侠古风', count: '178部', color: 'bg-primary-100 text-primary-700' },
  { emoji: '🏫', name: '校园青春', count: '234部', color: 'bg-accent-100 text-accent-700' },
  { emoji: '🌌', name: '科幻未来', count: '156部', color: 'bg-secondary-100 text-secondary-700' },
];

export default function IndexSection() {
  return (
    <section id="index" className="w-full bg-background-100 py-14 md:py-20">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">
            专题索引
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-[480px] mx-auto">
            按类型浏览妖精动漫全站漫画资源，快速找到你的心头好
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-3 md:gap-4 max-w-[900px] mx-auto">
          {categories.map((cat, i) => (
            <a
              key={i}
              href={`#index`}
              onClick={(e) => e.preventDefault()}
              className="group flex items-center gap-3 bg-background-50 border border-background-200/70 rounded-xl p-4 cursor-pointer hover:border-primary-200 transition-all duration-200"
            >
              <span className="w-10 h-10 flex items-center justify-center text-xl flex-shrink-0 rounded-lg bg-background-100">
                {cat.emoji}
              </span>
              <div className="min-w-0">
                <p className="text-sm font-medium text-foreground-800 group-hover:text-primary-500 transition-colors">
                  {cat.name}
                </p>
                <span className={`inline-block px-2 py-0.5 text-xs rounded-full mt-1 ${cat.color}`}>
                  {cat.count}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}